import React, { useEffect, useRef, useState, Fragment } from 'react'
import { Alert, Button } from 'react-bootstrap'
import Popup from 'reactjs-popup'
import InputField from '../../../../ui/InputField'
import useOptions from '../useOptions'
import { Query } from '../../../../utilities/incognitaAPI'
import { CREATE_MONITORING_TYPE, GET_CREDENTIAL_COMPONENTS, UPDATE_MONITORING_TYPE, GET_LOGICMONITOR_SYSTEM_CATEGORIES } from '../queries'
import SelectField from '../../../../ui/SelectField'
import Icon from 'UI/FontAwesomeIcon'
import { get, isEmpty, isNull, isObject, isUndefined } from 'lodash'
import CreateCredential from './CreateCredential'
import Divider from '../../../../ui/Divider'
import InformationAccordion from '../../../../ui/InformationAccordion'

const Form = ({ object, setObject }) => {
  const popupRef = useRef(null)
  const [credentials, setCredentials] = useState([])

  const getCredentials = () => {
    Query(GET_CREDENTIAL_COMPONENTS, { serviceName: 'Logicmonitor' })
      .then(res => {
        setCredentials(res.credentialComponents)
      })
  }

  const [systemCategories, setSystemCategories] = useState([])
  const getSystemCategories = () => {
    Query(GET_LOGICMONITOR_SYSTEM_CATEGORIES)
      .then(res => {
        setSystemCategories(res.logicmonitorSystemCategories)
      })
  }

  const [systemCategoriesOptions, setSystemCategoriesOptions] = useState([])

  const getSystemCategoryOptions = () => {
    setSystemCategoriesOptions(systemCategories.map(category => (
      { label: category.category, value: category.id }
    )))
  }

  const fillField = () => {
    setId(object?.id)
    setMonitoringType(object?.monitoringType || "")
    setConnectionType(options.connectionTypes.find(o => o.value === object?.connectionType))
    setCollectorType(options.collectorTypes.find(o => o.value === object?.collectorType))
    setServiceUrlPropertyName(object?.serviceUrlPropertyName || "")
    setSelectedCredentials(options.credentials.filter(o => object?.credentialIds?.includes(String(o.value))))
    setSelectedSystemCategories(systemCategoriesOptions.filter(o => object?.logicmonitorSystemCategories?.map(c=>c.id)?.includes(String(o.value))))
    setErrors({})
  }

  const options = useOptions({ credentials })

  const [errors, setErrors] = useState({})
  const [alert, setAlert] = useState({})
  const [loading, setLoading] = useState(false)
  const [popupOpen, setPopupOpen] = useState(false)

  const [id, setId] = useState(undefined)
  const [monitoringType, setMonitoringType] = useState('')
  const [connectionType, setConnectionType] = useState({})
  const [collectorType, setCollectorType] = useState({})
  const [serviceUrlPropertyName, setServiceUrlPropertyName] = useState('')
  const [selectedCredentials, setSelectedCredentials] = useState([])
  const [selectedSystemCategories, setSelectedSystemCategories] = useState([])

  const [systemCategoryValue, setSystemCategoryValue] = useState('')
  const [addSystemCategoryWasClicked, setAddSystemCategoryWasClicked] = useState(false)

  useEffect(() => {
    getCredentials()
    getSystemCategories()
    getSystemCategoryOptions()

    if (isObject(object)) setPopupOpen(true)
    else setPopupOpen(false)

    if (addSystemCategoryWasClicked){
      setSelectedSystemCategories([...selectedSystemCategories, systemCategoriesOptions[0]])
      setAddSystemCategoryWasClicked(false)
    }
  }, [object, addSystemCategoryWasClicked])

  const closePopup = () => {
    popupRef.current.close()
    fillField()
    setSystemCategoryValue('')
    setObject(null)
    setAlert({})
  }

  const openPopup = () => {
    popupRef.current.open()
    fillField()
  }
  const mapSystemCategories = () => {
    var createSystemCategories = []
    for (var category in selectedSystemCategories) {
      createSystemCategories.push(
        { 
          'category': selectedSystemCategories[category].label,
          'id': selectedSystemCategories[category].value
        }
      )
    }

    return createSystemCategories
  }

  const save = () => {
    isUndefined(id) ? create() : update()
  }

  const create = () => {
    setLoading(true)

    Query(CREATE_MONITORING_TYPE, {
      monitoringType,
      connectionType: connectionType?.value,
      collectorType: collectorType?.value,
      serviceUrlPropertyName,
      credentialIds: selectedCredentials?.map(c => c.value),
      logicmonitorSystemCategories: mapSystemCategories()
    }).then(res => {
      if (isNull(res.createLogicmonitorMonitoringType?.errors)) {
        setErrors({})
        setAlert({
          text: 'Monitoring type has been successfully created!',
          variant: 'success'
        })
      } else {
        setErrors(res.createLogicmonitorMonitoringType?.errors)
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const update = () => {
    setLoading(true)

    Query(UPDATE_MONITORING_TYPE, {
      id: id,
      monitoringType: monitoringType,
      connectionType: connectionType?.value,
      collectorType: collectorType?.value,
      serviceUrlPropertyName,
      credentialIds: selectedCredentials?.map(c => c.value) || [],
      logicmonitorSystemCategories: mapSystemCategories()
    }).then(res => {
      console.log(res)
      if (isNull(res.updateLogicmonitorMonitoringType?.errors)) {
        setErrors({})
        setAlert({
          text: 'Monitoring type has been successfully updated!',
          variant: 'success'
        })
      } else setErrors(res.updateLogicmonitorMonitoringType?.errors)
    }).finally(() => setLoading(false))
  }

  return (
    <Popup
      className="p-8"
      modal
      contentStyle={{ width: '50%' }}
      ref={popupRef}
      onOpen={openPopup}
      onClose={closePopup}
      open={popupOpen}
    >
      <div className="p-10">
      <h3 className="text-gray-600 mb-10">{id ? 'Update' : 'Create'} Monitoring Type</h3>

      {alert.text && (
        <Alert variant={alert.variant} dismissible onClose={() => setAlert({})}>
          {alert.text}
        </Alert>
      )}

      <InputField
        className="mb-2"
        value={monitoringType}
        onChange={e => setMonitoringType(e.target.value)}
        label="Monitoring Type"
        error={errors?.monitoringType}
      />

      <SelectField
        className="mb-2"
        label="Connection Type"
        options={options.connectionTypes}
        onChange={setConnectionType}
        value={connectionType}
        error={errors?.connectionType}
      />

      <SelectField
        className="mb-2"
        label="Collector Type"
        options={options.collectorTypes}
        onChange={setCollectorType}
        value={collectorType}
        error={errors?.collectorType}
      />

      <InputField
        className="mb-2"
        label="Service URL Property Name"
        value={serviceUrlPropertyName}
        onChange={e => setServiceUrlPropertyName(e.target.value)}
        error={errors?.serviceUrlPropertyName}
      />
      
      <Divider className="mb-2" text="SYSTEM CATEGORIES" />

      <InformationAccordion 
        information={<Fragment><p className="text-gray-500">Logicmonitor system categories are used to explicitly assign monitoring services to a device. Information about how to identify which system categories are required can be found <a href='https://www.logicmonitor.com/support/devices/adding-managing-devices/how-does-logicmonitor-know-what-to-monitor-for-a-device' target='_blank'>here.</a></p></Fragment>}
      />

      <SelectField
        className="mb-4"
        label="System Categories"
        options={systemCategoriesOptions}
        onChange={setSelectedSystemCategories}
        value={selectedSystemCategories}
        isMulti
      />

      <div className="mb-2 flex">
        <InputField
          className="flex-col"
          label="Add New System Category"
          value={systemCategoryValue}
          onChange={e => setSystemCategoryValue(e.target.value)}
          error={errors?.serviceUrlPropertyName}
        />

        <div className='mt-8 mx-2'>
          <Icon
            className={`flex-col text-2xl duration-300 hover:text-blue-600 text-gray-400 cursor-pointer`}
            icon='plus-circle'
            onClick={() => {
              if (systemCategoryValue.length == 0) {
                return
              }

              setSystemCategories( 
                [
                  { category: systemCategoryValue },
                  ...systemCategories
                ]
              )

              setSystemCategoriesOptions( 
                [
                  { label: systemCategoryValue },
                  ...systemCategoriesOptions
                ]
              )

              setAddSystemCategoryWasClicked(true)
            }
          }
          />
        </div>
      </div>

      <Divider className="mb-2" text="CREDENTIAL NAMES" />

      <InformationAccordion 
        information={<Fragment><p className="text-gray-500">Many Logicmonitor data sources require authentication credentials to communicate with services hosted on a device. These secrets are remembered as custom properties, which have a name and value. The name is used to identify the credential in Logicmonitor's data collection scripts, and the value is the actual credential used to authenticate.
        The section of the form below is used to declare which custom property names will be set for this monitoring type, the values of these properties are managed on the monitoring configuration page. Information about credential requirements can be found <a href='https://www.logicmonitor.com/support/getting-started/advanced-logicmonitor-setup/defining-authentication-credentials' target='_blank'>here.</a></p></Fragment>}
      />

      <SelectField
        className="mb-4"
        label="Logicmonitor Credential Names"
        options={options.credentials}
        onChange={setSelectedCredentials}
        value={selectedCredentials}
        isMulti
      />

      <CreateCredential getCredentials={getCredentials} />

        <div className="flex justify-end mt-10">
          <Button
            variant="outline-danger"
            className="mr-4"
            onClick={closePopup}
          >
            Discard
          </Button>

          <Button onClick={save}>
            {loading && <Icon className="mr-1 animate-spin" icon="spinner" />}
            {id ? 'Update' : 'Create'}
          </Button>
        </div>

        <div className="text-gray-500 mt-8 flex">
          <Icon className="mr-2 text-blue-500 text-2xl" icon="info-circle" />
          
          <div>
            Go

            <a
              className="mx-1"
              href="https://www.logicmonitor.com/support/devices/adding-managing-devices/how-does-logicmonitor-know-what-to-monitor-for-a-device"
              target="_blank" 
            >
              here
            </a>

            for a guide on how to identify the credentials required for
            each monitoring type.
          </div>
        </div>
      </div>
    </Popup>
  )
}

export default Form